import React from 'react'
import rehypeRaw from 'rehype-raw'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { Components } from 'react-markdown'

export type HtmlMarkdownRendererProps = {
  children: string
  components?: Components
}

export const HtmlMarkdownRenderer = ({ children, components, ...rest }: HtmlMarkdownRendererProps) => {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={components} {...rest}>
      {children}
    </ReactMarkdown>
  )
}
